export const homePageTranslations = {
    English: {
        Home: "Home",
        Resources: "Resources",
        SuccessStories: "Success Stories",
        DeliverCompelling: "Deliver compelling experiences at scale by",
        Showcasing: "Showcasing your products and services",
        Boosting: "Boosting sales for your small business",
        Building: "Building stronger relationships",
        AllThroughWhatsApp: "All Through WhatsApp",
        WhatsAppBusinessProducts:
            "WhatsApp Business products empower local businesses to streamline customer queries, manage orders, and boost promotions, all while redefining small business communication",
        EngageAudiences: "Engage audiences, accelerate sales, and learn how to improve customer support on a platform with",
        UsersAround: "Users around the world",
        ThreeBillion: "3 Billion+",
        GrowYourBusiness: "Grow Your Business Smarter",
        ShareYourJourney: "Share your journey and challenges—get help with digital efficiency tools by WhatsApp that support your next step",
        FullName: "Full Name",
        PhoneNumber: "Phone Number",
        EmailID: "Email ID",
        BusinessName: "Business Name",
        DescribeBusiness: "Please describe your business, what you offer, and your current digital promotion or sales challenges.",
        WhereHelpMost: "Where do you think WhatsApp Business can help you most—support, communication, promotion, or customer engagement?",
        Consent: "By ticking this box, you consent to Josh Talks collecting and sharing your information with Meta/Meta's onboarded partners, who may contact you with marketing messages related to its business, products, and services. You may withdraw your consent at any time, by clicking the unsubscribe button in your emails.",
        Submit: "Submit",
        SimplifyBusiness: "Simplify Business Operations",
        WithWhatsApp: "with Whatsapp!",
        ManageChats: "Manage chats, organize orders, showcase your catalog, and connect faster—all from the best free app <br/>for small business owners",
        FullFeatureDetails: "For full feature details, visit the official",
        WhatsAppBusinessApp: "WhatsApp Business app",
        page: "page",
        DescribeHere: "Describe here",
        allThrough: 'All Through',
        whatsApp: "WhatsApp",
        video: "https://storage.googleapis.com/joshtalks-ias.appspot.com/meta/montage-video.mp4"
    },

    हिंदी: {
        Home: "होम",
        Resources: "संसाधन",
        SuccessStories: "सफलता की कहानियाँ",
        DeliverCompelling: "बड़े स्तर पर प्रभावशाली अनुभव प्रदान करें",
        Showcasing: "ग्राहकों के साथ मज़बूत रिश्ते बनायें",
        Boosting: "अपने उत्पादों और सेवाओं को प्रदर्शित करें",
        Building: "अपने व्यवसाय की बिक्री बढ़ायें",
        AllThroughWhatsApp: "सभी व्हाट्सएप के माध्यम से",
        WhatsAppBusinessProducts:
            "WhatsApp Business के प्रोडक्ट्स की मदद से आप ग्राहकों के सवालों का आसानी से जवाब दे सकते हैं, ऑर्डर बेहतर तरीके से संभाल सकते हैं और अपने प्रमोशन को बढ़ा सकते हैं। इससे छोटे व्यवसायों का ग्राहकों से जुड़ने और बातचीत करने का तरीका भी और बेहतर बनता है।",
        EngageAudiences: "दुनिया भर में 3 अरब से ज़्यादा उपयोगकर्ताओं वाले इस प्लेटफ़ॉर्म के साथ अपने ग्राहकों से आसानी से जुड़ें, बिक्री बढ़ाएँ और ग्राहक सहायता को बेहतर बनाने के नए तरीके सीखें।",
        UsersAround: "उपयोगकर्ता दुनिया भर में हैं।",
        ThreeBillion: "3 अरब+",
        GrowYourBusiness: "अपने व्यवसाय को समझदारी से बढ़ाएँ।",
        ShareYourJourney: "अपनी यात्रा और चुनौतियाँ साझा करें — WhatsApp के डिजिटल टूल्स की मदद पाएं, जो आपके अगले कदम में सहारा बन सकते हैं।",
        FullName: "पूरा नाम",
        PhoneNumber: "फोन नंबर",
        EmailID: "ईमेल आईडी",
        BusinessName: "व्यवसाय का नाम",
        DescribeBusiness: "अपने व्यवसाय के बारे में बताएं — आप क्या बेचते या प्रदान करते हैं, और फिलहाल डिजिटल मार्केटिंग या बिक्री में आपको किन कठिनाइयों का सामना करना पड़ रहा है?",
        WhereHelpMost: "आपको क्या लगता है, WhatsApp Business आपके लिए सबसे ज़्यादा किस क्षेत्र में मददगार हो सकता है — ग्राहक सहायता, बातचीत, प्रचार-प्रसार या ग्राहक से जुड़ाव?",
        Consent: "इस बॉक्स पर टिक करके, आप Josh Talks को अपनी जानकारी Meta या Meta से जुड़े पार्टनर्स के साथ साझा करने की अनुमति देते हैं, जो आपसे अपने व्यापार, उत्पादों और सेवाओं से जुड़ी मार्केटिंग जानकारी के लिए संपर्क कर सकते हैं। आप किसी भी समय अपने ईमेल में अनसब्सक्राइब बटन पर क्लिक करके अपनी सहमति वापस ले सकते हैं।",
        Submit: "जमा करें",
        SimplifyBusiness: "अपने व्यवसाय को आसानी से संभालें, WhatsApp के साथ!",
        WithWhatsApp: "WhatsApp के साथ।",
        ManageChats: "छोटे व्यवसाय मालिकों के लिए बना यह मुफ़्त ऐप आपको अपने कामकाज को बेहतर तरीके से संभालने में मदद करता है। ग्राहकों से बात करना, ऑर्डर व्यवस्थित रखना और अपने प्रोडक्ट्स का कैटलॉग दिखाना - सब कुछ एक ही जगह पर। सभी फीचर्स की पूरी जानकारी के लिए WhatsApp Business ऐप के ऑफ़िशियल पेज पर जाएँ।",
        FullFeatureDetails: "सभी विशेषताओं की पूरी जानकारी के लिए, आधिकारिक",
        WhatsAppBusinessApp: "WhatsApp Business ऐप",
        page: "पेज पर जाएं।",
        DescribeHere: "यहाँ वर्णन करें",
        allThrough: 'ऑल थ्रू',
        whatsApp: "WhatsApp",
        video: "https://storage.googleapis.com/joshtalks-ias.appspot.com/image_data/wab-hin.mp4"
    },

    मराठी: {
        Home: "होम",
        Resources: "संसाधने",
        SuccessStories: "यशोगाथा",
        DeliverCompelling: "मोठ्या प्रमाणावर आकर्षक अनुभव द्या",
        Showcasing: "तुमची उत्पादने आणि सेवा प्रदर्शित करणे",
        Boosting: "तुमच्या लघु व्यवसायाची विक्री वाढवणे",
        Building: "अधिक मजबूत नातेसंबंध निर्माण करणे",
        AllThroughWhatsApp: "सर्व व्हॉट्सअॅपद्वारे",
        WhatsAppBusinessProducts:
            "WhatsApp Business ची उत्पादने स्थानिक व्यवसायांना ग्राहकांच्या चौकश्या सुलभपणे हाताळण्यासाठी, ऑर्डर्स व्यवस्थापित करण्यासाठी आणि प्रमोशन्स वाढवण्यासाठी सक्षम करतात, तसेच लहान व्यवसायांच्या संवादपद्धतीला नव्याने आकार देतात.",
        EngageAudiences: "प्रेक्षकांशी संलग्न व्हा, विक्री वाढवा, आणि ग्राहक सहाय्य कसे सुधारायचे ते शिका अशा प्लॅटफॉर्मवर",
        UsersAround: "जगभरातील वापरकर्ते",
        ThreeBillion: "३ अब्ज+",
        GrowYourBusiness: "तुमचा व्यवसाय स्मार्टपणे वाढवा",
        ShareYourJourney: "तुमचा प्रवास आणि आव्हाने शेअर करा - तुमच्या पुढील पायरीला पाठिंबा देणाऱ्या डिजिटल कार्यक्षमता साधनांसह WhatsApp द्वारे मदत मिळवा.",
        FullName: "पूर्ण नाव",
        PhoneNumber: "फोन नंबर",
        EmailID: "ईमेल आयडी",
        BusinessName: "व्यवसायाचे नाव",
        DescribeBusiness: "कृपया तुमचा व्यवसाय, तुम्ही काय देता आणि सध्याच्या डिजिटल प्रचार किंवा विक्रीतील अडचणी सांगा.",
        WhereHelpMost: "तुम्हाला काय वाटते, WhatsApp Business तुम्हाला सर्वात जास्त कुठे मदत करू शकते - सपोर्ट, कम्युनिकेशन, प्रमोशन किंवा ग्राहकांशी संवाद?",
        Consent: "या बॉक्सवर टिक करून, तुम्ही Josh Talks तुमची माहिती गोळा करण्यास आणि Meta/Meta's ऑनबोर्डेड भागीदारांसह शेअर करण्यास संमती देता, जे त्यांच्या व्यवसाय, उत्पादने आणि सेवांशी संबंधित मार्केटिंग संदेशांसह तुमच्याशी संपर्क साधू शकतात. तुमच्या ईमेलमधील सदस्यता रद्द करा बटणावर क्लिक करून तुम्ही कधीही तुमची संमती मागे घेऊ शकता.",
        Submit: "जमा",
        SimplifyBusiness: "व्यवसायाच्या प्रक्रिया सुलभ करा",
        WithWhatsApp: "WhatsApp सोबत!",
        ManageChats: "चॅट्स व्यवस्थापित करा, ऑर्डर्स नीट संघटित करा, तुमचा कॅटलॉग प्रदर्शित करा आणि लवकरात लवकर कनेक्ट व्हा—हे सर्व लहान व्यवसाय मालकांसाठी सर्वोत्तम मोफत ॲपमधून.",
        FullFeatureDetails: "संपूर्ण फीचर्सची माहिती मिळवण्यासाठी अधिकृत WhatsApp Business ॲपच्या पेजला भेट द्या.",
        WhatsAppBusinessApp: "WhatsApp Business अँप",
        page: "पृष्ठ",
        DescribeHere: "येथे वर्णन करा",
        allThrough: "सर्व काही",
        whatsApp: "WhatsApp",
        video: "https://storage.googleapis.com/joshtalks-ias.appspot.com/image_data/wab-marathi.mp4"
    },

    বাংলা: {
        Home: "হোম",
        Resources: "রিসোর্সেস",
        SuccessStories: "সাকসেস স্টোরিস",
        DeliverCompelling: "বড় পরিসরে আকর্ষণীয় অভিজ্ঞতা দিন",
        Showcasing: "আপনার পণ্য এবং পরিষেবাগুলি প্রদর্শন করা",
        Boosting: "আপনার ছোট ব্যবসার বিক্রয় বৃদ্ধি করা",
        Building: "এবং শক্তিশালী সম্পর্ক তৈরি করা",
        AllThroughWhatsApp: "সবকিছু হোয়াটসঅ্যাপ-এ",
        WhatsAppBusinessProducts:
            "WhatsApp Business পণ্যগুলি স্থানীয় ব্যবসাগুলিকে গ্রাহকদের জিজ্ঞাসাগুলি সুবিন্যস্ত করতে, অর্ডার পরিচালনা করতে এবং প্রচারগুলিকে বাড়িয়ে তুলতে সহায়তা করে, যা ছোট ব্যবসার যোগাযোগের ধারণাকে সম্পূর্ণ নতুনভাবে সংজ্ঞায়িত করে",
        EngageAudiences: "গ্রাহকদের নিযুক্ত করুন, বিক্রয়কে ত্বরান্বিত করুন এবং কীভাবে উন্নতি করবেন তা শিখুন একটি প্ল্যাটফর্মে গ্রাহক সহায়তা ফলাফল সহ",
        UsersAround: "ব্যবহারকারীরা বিশ্বজুড়ে",
        ThreeBillion: "৩ বিলিয়ন+",
        GrowYourBusiness: "আপনার ব্যবসা আরও স্মার্টভাবে বাড়ান",
        ShareYourJourney: "আপনার যাত্রা এবং চ্যালেঞ্জগুলি শেয়ার করুন—WhatsApp ের ডিজিটাল গুরুত্বপূর্ণ টুলস গুলির সাহায্যে আপনার পরবর্তী পদক্ষেপের জন্য সহায়তা পান",
        FullName: "পূর্ণ নাম",
        PhoneNumber: "ফোন নম্বর",
        EmailID: "ইমেল আইডি",
        BusinessName: "ব্যবসার নাম",
        DescribeBusiness: "আপনার ব্যবসা, আপনি কী অফার করেন এবং আপনার বর্তমান ডিজিটাল প্রচার বা বিক্রয় চ্যালেঞ্জগুলি বর্ণনা করুন।",
        WhereHelpMost: "আপনার মতে WhatsApp Business আপনাকে সবচেয়ে বেশি সাহায্য করতে পারে কোন ক্ষেত্রে—সহায়তা, যোগাযোগ, প্রচার, নাকি গ্রাহকের মনোযোগ?",
        Consent: "এই বাক্সে টিক চিহ্ন দিয়ে, আপনি Josh Talks আপনার তথ্য সংগ্রহ করতে এবং Meta/Meta তালিকাভুক্ত অংশীদারদের সাথে শেয়ার করতে সম্মতি দিচ্ছেন, যারা আপনাকে তাদের ব্যবসা, পণ্য এবং পরিষেবা সম্পর্কিত বিপণন বার্তা পাঠাতে পারে। আপনি যেকোনো সময় আপনার ইমেলের আনসাবস্ক্রাইব বোতামে ক্লিক করে আপনার সম্মতি প্রত্যাহার করতে পারেন l",
        Submit: "জমা দিন",
        SimplifyBusiness: "ব্যবসায়িক কার্যক্রম সহজ করুন",
        WithWhatsApp: "WhatsApp!",
        ManageChats: "চ্যাট পরিচালনা করুন, অর্ডার গুছিয়ে নিন, আপনার ক্যাটালগ প্রদর্শন করুন, এবং আরও দ্রুত সংযোগ স্থাপন করুন—এই সবকিছুই করুন ক্ষুদ্র ব্যবসায়ীদের জন্য সেরা ফ্রি অ্যাপটি থেকে",
        FullFeatureDetails: "সম্পূর্ণ বৈশিষ্ট্যের বিবরণ জানতে, অফিসিয়াল অ্যাপ পেজটি দেখুন",
        WhatsAppBusinessApp: "WhatsApp Business",
        page: "পেজ",
        DescribeHere: "এখানে বর্ণনা করুন",
        allThrough: "অল থ্রু",
        whatsApp: "WhatsApp",
        video: "https://storage.googleapis.com/joshtalks-ias.appspot.com/image_data/wab-bengali.mp4"
    },

    தமிழ்: {
        Home: "ஹோம்",
        Resources: "ரிஸோர்சஸ்",
        SuccessStories: "சக்சஸ் ஸ்டோரிஸ்",
        DeliverCompelling: "பெரிய அளவில் ஈர்க்கக்கூடிய அனுபவங்களை வழங்குவதன் மூலம்",
        Showcasing: "உங்கள் பொருட்கள் மற்றும் சேவைகளை எல்லோருக்கும் தெரியப்படுத்துங்கள்",
        Boosting: "உங்கள் சிறிய வியாபாரத்தின் விற்பனையை அதிகரியுங்கள்",
        Building: "வாடிக்கையாளர்களுடன் நல்ல உறவை உருவாக்குங்கள்",
        AllThroughWhatsApp: "அனைத்தும் வாட்ஸ் ஆப் மூலம்",
        WhatsAppBusinessProducts:
            "WhatsApp Business வசதிகள், உள்ளூர் வியாபாரங்களுக்கு வாடிக்கையாளர்களின் கேள்விகளை எளிதாக நிர்வகிக்க, ஆர்டர்களை கவனிக்க, மற்றும் சலுகைகளை விரிவாக தெரியப்படுத்த உதவுகின்றன. இதன் மூலம் சிறிய வியாபாரங்களின் தொடர்பு முறையே மேலும் சிறப்பாக மாறுகிறது.",
        EngageAudiences: "பார்வையாளர்களை ஈர்க்கவும் | விற்பனையை அதிகரிக்கவும் | வாடிக்கையாளர் உதவியை மேம்படுத்தவும் கற்றுக்கொள்ளுங்கள்",
        UsersAround: "உலகம் முழுவதும் பயனர்கள்",
        ThreeBillion: "3 பில்லியன்+",
        GrowYourBusiness: "உங்கள் வணிகத்தை புத்திசாலித்தனமாக வளர்க்கவும்",
        ShareYourJourney: "உங்கள் பயணத்தையும் சவால்களையும் பகிர்ந்து கொள்ளுங்கள் — உங்கள் அடுத்த கட்ட முன்னேற்றத்திற்குத் தேவைப்படும் டிஜிட்டல் செயல்திறன் கருவிகளை WhatsApp வழியாகப் பெறுங்கள்",
        FullName: "முழு பெயர்",
        PhoneNumber: "தொலைபேசி எண்",
        EmailID: "மின்னஞ்சல் ஐடி",
        BusinessName: "வணிகத்தின் பெயர்",
        DescribeBusiness: "உங்கள் வணிகம், நீங்கள் வழங்குவது மற்றும் தற்போதைய டிஜிட்டல் விளம்பர அல்லது விற்பனை சவால்கள் பற்றி விவரிக்கவும்.",
        WhereHelpMost: "WhatsApp Business உங்களுக்கு அதிகம் உதவக்கூடிய பகுதி எது என்று எண்ணுகிறீர்கள்? உதாரணமாக: ஆதரவு, தொடர்பு, பிரச்சாரம் அல்லது வாடிக்கையாளர் ஈடுபாடு?",
        Consent: "இந்த பெட்டியை குறிக்கும் மூலம், நீங்கள் Josh Talks உங்கள் தகவல்களை சேகரித்து, Meta அல்லது Meta-ன் கூட்டாளிகள் ஆகியோருடன் பகிர அனுமதிக்கிறீர்கள். அவர்கள் தங்களது வணிகம், தயாரிப்புகள் மற்றும் சேவைகளுக்கு தொடர்பான மார்க்கெட்டிங் செய்திகள் உடன் உங்களை தொடர்புகொள்வார்கள்.நீங்கள் எப்போது வேண்டுமானாலும், உங்கள் மின்னஞ்சலில் உள்ள குழுவிலகவும் பொத்தானை கிளிக் செய்வதன் மூலம் இந்த அனுமதியை திரும்ப பெறலாம்.",
        Submit: "சமர்ப்பிக்கவும்",
        SimplifyBusiness: "WhatsApp மூலம் வியாபாரத்தை எளிதாக்குங்கள்!",
        WithWhatsApp: "WhatsApp!",
        ManageChats: "அரட்டைகளை நிர்வகிக்கவும், ஆர்டர்களை ஒழுங்குபடுத்தவும், உங்கள் பட்டியலை காட்சிப்படுத்தவும்,<br/> சிறு வணிகர்களுக்கான சிறந்த இலவச செயலியில் விரைவாக இணைக்கவும்",
        FullFeatureDetails: "மற்ற முழு விபரங்களுக்கு ,அதிகாரப்பூர்வ செயலியின் பக்கத்தை பார்க்கவும்",
        WhatsAppBusinessApp: "WhatsApp Business",
        page: "பக்கம்",
        DescribeHere: "இங்கே விவரிக்கவும்",
        allThrough: "ஆல் த்ரூ",
        whatsApp: "வாட்ஸ் ஆப்",
        video: "https://storage.googleapis.com/joshtalks-ias.appspot.com/wab-tamil.mp4"
    },
    ગુજરાતી: {
        Home: "હોમ",
        Resources: "રીસોર્સ",
        SuccessStories: "સફળતાની વાર્તાઓ",
        DeliverCompelling: "વિશિષ્ટ અનુભવ પ્રદાન કરો વ્યાપક પાયે",
        Showcasing: "તમારા પ્રોડક્ટ્સ અને સેવાઓ પ્રદર્શિત કરે છે",
        Boosting: "તમારા વ્યવસાય માટે વેચાણને વેગ આપવો",
        Building: "વધુ મજબૂત સંબંધો બનાવો",
        AllThroughWhatsApp: "બધા WhatsApp દ્વારા",
        WhatsAppBusinessProducts:
            "WhatsApp Business WhatsApp Business એ પ્રોડક્ટ્સ અને સ્થાનિક વ્યવસાયોને ગ્રાહકોના પ્રશ્નોને સરળ બનાવવા, ઓર્ડર મેનેજ કરવા અને પ્રમોશન વધારવા માટે સશક્ત બનાવે છે, આ બધું બિઝનેસ કોમ્યુનિકેશનને વ્યાખ્યાયિત કરવું ખુબ જ સરળ છે.",
        EngageAudiences: "દર્શકોને જોડો, વેચાણમાં ઝડપ લાવો અને ગ્રાહક સેવા કેવી રીતે સુધારવી તે શીખો",
        UsersAround: "વિશ્વભરમાં વપરાશકર્તાઓ",
        ThreeBillion: "3 અબજ+",
        GrowYourBusiness: "તમારું વ્યવસાય વધુ સ્માર્ટ બનાવો",
        ShareYourJourney: "તમારી મુસાફરી અને પડકારો શેર કરો—WhatsApp દ્વારા ડિજિટલ કાર્યક્ષમતા સાધનોની સહાય મેળવો જે તમારા આગલા પગલાંને સમર્થન આપે છે",
        FullName: "પૂર્ણ નામ",
        PhoneNumber: "ફોન નંબર",
        EmailID: "ઇમેલ આઈડી",
        BusinessName: "વ્યવસાયનું નામ",
        DescribeBusiness: "કૃપા કરીને તમારા વ્યવસાયનું વર્ણન કરો, તમે શું ઓફર કરો છો, અને હાલની ડિજિટલ પ્રમોશન અથવા વેચાણની સમસ્યાઓ જણાવો.",
        WhereHelpMost: "તમને શું લાગે છે કે WhatsApp Business તમને સૌથી વધુ ક્યાં મદદ કરી શકે છે - સપોર્ટ, વાતચીત, પ્રમોશન અથવા ગ્રાહક જોડાણ?",
        Consent: "આ બૉક્સ પર ટિક કરીને, તમે Josh Talks તમારી માહિતી Meta/Meta ઑનબોર્ડેડ ભાગીદારો સાથે એકત્રિત કરવા અને શેર કરવા માટે સંમતિ આપો છો, જેઓ તેના વ્યવસાય, પ્રોડક્ટ્સ અને સેવાઓ સંબંધિત માર્કેટિંગ સંદેશાઓ સાથે તમારો સંપર્ક કરી શકે છે. તમે તમારા ઈમેઈલમાં અનસબ્સ્ક્રાઈબ બટન પર ક્લિક કરીને કોઈપણ સમયે તમારી સંમતિ પાછી ખેંચી શકશો.",
        Submit: "સબમિટ કરો",
        SimplifyBusiness: "વ્યવસાયિક પ્રક્રિયાઓ સરળ બનાવો વડે",
        WithWhatsApp: "WhatsApp!",
        ManageChats: "ચેટ ને મેનેજ કરો, ઓર્ડર ને ઓર્ગેનાઇઝ કરો, તમારું કેટલોગ બતાવો, અને તે માટેઝડપી આમા જોડાવો— વ્યવસાય માલિકો માટે What'sApp Business શ્રેષ્ઠ ફ્રી એપ છે.",
        FullFeatureDetails: "સંપૂર્ણ ફીચરની વિગતો માટે, મુલાકાત લો અધિકૃત",
        WhatsAppBusinessApp: "WhatsApp Business એપ",
        page: "પાનું",
        DescribeHere: "અહીં વર્ણન કરો",
        allThrough: "ઓલ થ્રુ",
        whatsApp: "WhatsApp",
        video: "https://storage.googleapis.com/joshtalks-ias.appspot.com/image_data/wab-guj.mp4"
    }
};